module.exports = __webpack_public_path__ + "static/offer-7aba3a8a929d1378c95b7fa91358765f.png";